// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const cn = {
  game: '游戏',
  games: '游戏',
  sport: '运动',
  center: '中心',
  mines: '地雷',
  home: '首页',
  crash: '崩溃',
  lucky_colour: '幸运颜色',
  dice: '骰子',
  limbo: '临界',
  lucky_gift: '幸运礼物',
  all_games: '所有游戏',
  game_history: '游戏历史',
  coupon_code: '优惠券代码',
  telegram: '电报',
  customer_service: '客户服务',
  player: '玩家',
  winner: '赢家',
  all_bets: '所有投注',
  my_bets: '我的投注',
  name: '姓名',
  time: '时间',
  bet_amount: '投注金额',
  prediction: '预测',
  payout: '支付',
  login: '登录',
  register: '注册',
  username_placeholder: '用户名',
  please_input_your_x: '请输入您的{{x}}',
  affiliate_referral: `联盟/推荐ID（可选）`,
  affiliates: `联盟/推荐`,
  captcha: '验证码',
  forgot_password: '忘记密码',
  minor_note: '访问本网站，请确保您已满18岁并同意',
  terms_of_service: '服务条款',
  by_signing_in: '通过登录或注册，您同意我们的',
  dont_have_account: '没有账户？',
  sign_up: '注册',
  delete_bank_account: `删除银行账户`,
  opps: `哎呀！`,
  web: `网络`,
  you_currently_unable: `您目前无法删除/编辑您的银行账户。请联系我们的客户支持以获取更多帮助。`,
  username: '用户名',
  email: '电子邮件',
  full_name: '全名',
  confirm_18: '点击注册按钮，即表示我确认自己已年满18岁，并已阅读并接受您的',
  already_have_account: '已有账户？',
  transfer: '转移',
  bank_details: '银行详情',
  change: `改变`,
  set_now: `立即设置`,
  add_your_birthday: `添加您的生日`,
  edit_delete_bank_account: `编辑/删除银行账户`,
  add_bank_account: `添加银行账户`,
  uuid: '通用唯一标识符',
  login_password: `登录密码`,
  edit_profile: '编辑个人资料',
  hint: '暗示',
  currency: `货币`,
  country: `国家`,
  confirm_logout: `确认退出?`,
  share: '分享',
  deposit: '存款',
  promos: '促销',
  bonus: '奖金',
  app: '应用程序',
  load_more: '加载更多',
  details: '详情',
  helps: '帮助',
  kyc_policy: 'KYC政策',
  privacy_policy: '隐私政策',
  responsible_gaming: '责任博彩',
  terms_and_condition: '条款和条件',
  faq: '常见问题',
  about_us: '关于我们',
  about_us_profile: '关于我们',
  amount: '金额',
  minimum: `最小值`,
  maximum: `最大值`,
  enter_amount: `輸入金額`,
  extra: '额外',
  deposit_bonus: '存款奖金',
  do_not_participate: '不参加促销',
  payment_problem: '支付问题',
  click_for_help: '点击寻求帮助',
  deposit_notes: '存款说明',
  available_balance: '可用余额',
  withdraw: '提款',
  withdrawal: '提款',
  withdrawal_notes: '提款说明',
  withdrawal_note1: '当前提款次数',
  withdrawal_note1_1: 'vip',
  withdrawal_note2: '提款费用：',
  min: '最低：',
  max: '最高：',
  opening_times: '开放时间：',
  withdrawal_note3: `1.最快提款时间为10分钟内`,
  withdrawal_note4: `2.请确保您的提款信息准确无误，如果提款信息有误，可能会导致资金损失。`,
  withdrawal_note5: `3.如有任何疑问，请随时联系我们。`,
  notifications: `通知`,
  invalid_x: `无效的{{x}}`,
  must_start_with: '必须以有效网络号码开头（例如 010、011、012、013、014、015、016、017、018、019）',
  captcha_not_match: `验证码不匹配`,
  invalid_x_must_be_atleast_y_characters: `无效的{{x}}，必须至少{{y}}个字符`,
  x_is_required: `{{x}}是必需的`,
  phone_number: `电话号码`,
  phone_num_x_max: `电话号码最多{{x}}位数字`,
  email_sent: `邮件已发送，请检查您的电子邮件。`,
  enter_valid_email: `请输入有效的电子邮件地址。`,
  confirm: `确认`,
  password_atleast_6_characters: `密码必须至少6个字符。`,
  password_reset_success: `密码重置成功！`,
  new_password: `新密码`,
  bank: `银行`,
  bank_transfer: `银行转账`,
  bank_name: `银行名称`,
  account_name: `账户名称`,
  account_number: `账号`,
  pix_number: `PIX号码`,
  drop_or_select: `拖放或选择文件`,
  drop_files_here: `将文件拖放到此处`,
  transfer_to: `转账至`,
  upload_receipt: `上传收据`,
  select_bonus: `选择奖金`,
  select_category: `选择类别`,
  see_all: `查看全部`,
  no_promotion: `没有促销`,
  please_upload_receipt: `请上传收据`,
  bank_account: `银行账户`,
  add_account: `添加账户`,
  account_holder_name: `账户持有人姓名`,
  name_of_the_account_holder: `账户持有人的姓名`,
  fill_in_bank_account: `填写银行账户信息`,
  withdraw_information: `提款信息`,
  note: `备注`,
  amount_withdrawn: `提款金额`,
  amount_no_exceed_balance: `提款金额不得超过可用余额`,
  minimum_withdraw_amount_is_x: `最低提款金额为{{x}}`,
  transaction_history: `交易历史`,
  date_from: `开始日期`,
  date_to: `结束日期`,
  acc: `ACC`,
  account_name_must_be_4: `账户名称长度必须大于4`,
  account_number_must_be_x: `账户号码长度必须为10到14位`,
  minimum_length_is_x: `最小长度为{{x}}`,
  maximum_length_is_x: `最大长度为{{x}}`,
  payment_method: `付款方式`,
  mode: `模式`,
  no_bank_account: `您没有可提款的账户，请立即添加`,
  please_select_bank: `请选择一个银行账户`,

  bet_history: `投注历史`,
  game_provider: `游戏提供商`,
  bet_count: `投注次数`,
  win_loss: `赢/输`,
  rebate: `返利`,
  turnover: `营业额`,
  game_category: `游戏类别`,
  loading: `加载中...`,
  you_have_x_unread_messages: `您有{{x}}条未读消息`,
  deposit_amount_between_x_and_y: `存款金额必须在{{x}}和{{y}}之间`,
  minimum_amount_is_x_y: `最低金额为{{x}}{{y}}`,
  balance: `余额`,
  all: `所有`,
  title: `标题`,
  date: `日期`,
  type: `类型`,
  status: `状态`,
  remark: `备注`,
  category: `类别`,
  please_select_x: `请选择{{x}}`,
  save: `保存`,
  please_select_lang: `请选择语言`,
  change_password: `更改密码`,
  current_password: `当前密码`,
  confirm_password: `确认新密码`,
  submit: `提交`,
  password_changed: `密码已更改`,
  x_must_be_y_characters: `{{x}}必须至少{{y}}个字符`,
  reset_password: `重置密码`,
  casino: `赌场`,
  slots: `老虎机`,
  slot: `投币口`,
  mobile_slot: `移动槽`,
  live_casino: `真人赌场`,
  fishing: `钓鱼`,
  sports: `体育`,
  cards: `牌类`,
  clear: `清除`,
  search: `搜索`,
  new: `新的`,
  logout: `登出`,
  choose_date: `选择日期`,
  select_both_date: `请选择开始和结束日期`,
  from: `从`,
  to: `到`,
  apply: `应用`,
  promotions: `促销`,
  learn_more: `了解更多`,
  password_doesnt_match: `密码不匹配`,
  cancel: `取消`,
  confirm_to_pay: `确认支付`,
  deposit_amount: `存款金额`,
  loading_please_wait: `加载中，请稍候`,
  account: `账户`,
  profile: `个人资料`,
  bank_list: `银行列表`,
  in_maintenance: `维护中`,
  birthday: `生日`,
  birthday_bonus: `生日奖金`,
  referral_code: `推荐码`,
  referral: `推荐`,
  my_referral: `我的推荐`,
  my_claim: `我的索赔`,
  claim_profit: `领取利润`,
  available_profit: `可用利润`,
  claimed_profit: `已领取利润`,
  all_time_profit: `总利润`,
  referral_note_on_x: `每次您的朋友在{{x}}上玩游戏时都会赚取利润`,
  tier: `级别`,
  commission: `佣金`,
  referred_member: `被推荐成员`,
  profit_earned: `赚取的利润`,
  account_information: `账户信息`,
  invite_friends: `邀请朋友`,
  how_it_work: `怎么运作？`,
  invite_note: `当您的朋友使用您的推荐码注册时，获得独家推荐奖金！`,
  share_via: `通过分享`,
  referral_link: `推荐链接`,
  total_profit: `总利润`,
  copied: `已复制`,
  nothing_to_claim: `没有可领取的`,
  claim_history: `索赔历史`,
  downline: `我的下线`,
  last_x_digit_bank_ref_number: `银行参考号码的最后{{x}}位数字`,
  bank_ref_number_validation_x: `银行参考号码是必需的，长度必须为{{x}}个字符`,
  sort: `排序`,
  login_directly: `直接登录`,
  our_game_provides: `我们的游戏提供商`,
  refer_and_reward: `推荐与奖励`,
  linked_successfully_x: `已成功连接{{x}}！请首次注册您的账户`,
  more_x_of_y: `更多{{x}}/{{y}}`,
  default: `默认`,
  promotion: `促销`,
  daily_mission: `每日任务`,
  agent: `代理`,
  contact_us: `联系我们`,
  download: `下载`,
  cash_claim: `现金领取`,
  demo: `演示`,
  favorites: `收藏`,
  popular: `热门`,
  claim_bonus: `领取奖金`,
  insufficient_balance: `余额不足`,
  currently_displaying: `当前显示{{z}}个游戏中的{{x}}个{{y}}游戏`,
  all_x: `所有{{x}}`,
  no_results: `未找到结果`,
  search_games: `搜索游戏`,
  please_scan_using_your: `请使用您的`,
  vip_level: `VIP等级`,
  bonus_direct: `直接奖金`,
  rebate_level: `返利等级`,
  vip_header: `在 Jit993 上，所有在老虎机、桌牌游戏、捕鱼、视频、体育和彩票游戏上投注的赌注将永久累计。有效投注 = 永久收入和财富！`,
  vip_example: `
  例子 1：累计存款达到 100 万的会员，达到 VIP 等级 2，获得 210 雷亚尔的奖金和 3.50% 的返利。当累计存款达到 600 万时，达到 VIP 等级 3，获得 800 雷亚尔的奖金和 4% 的返利`,
  activity_rules: `活动规则：`,
  activity_rules_1: `1. 所有奖金必须进行 x3 的投注才能申请提款`,
  activity_rules_2: `2. 请在截止日期内领取返利奖金，如果迟了，将被视为放弃；`,
  activity_rules_3: `3. 会员的活动参与情况由系统自动统计，如果有任何异议，以 Jit993 的调查结果为准；`,
  activity_rules_4: `4. 如果您忘记了会员账户/密码，请联系“24 小时在线客户服务”帮助您找回账户信息；`,
  activity_rules_5: `5. Jit993 保留随时更改、停止或取消本次促销活动的权利。`,
  activity_rules_6: `6. 不要保存免费游戏，购买免费游戏`,
  activity_rules_7: `7. 不能与任何奖金结合使用`,
  activity_rules_8: `8. 每次存款的最高提款金额为 R$100.000.00`,
  event_instructions: '活动说明',
  agent_p1: '在应用程序和社交媒体上分享您的唯一链接',
  agent_p2:
    'Facebook、Instagram、Tiktok、Telegram、WhatsApp、YouTube 等，赶快邀请大家，通过您的专属链接注册的会员将成为您的直接代理。但请注意，您邀请的新会员必须是真实和有效的。',
  agent_step1:
    '邀请朋友首次存款成功，您可以赢得 R$5 的奖金。例如，如果您邀请 10 人首次存款，您可以赚取 R$50。您邀请的人越多，获得的奖金就越多。您可以在促销页面查看您的历史和注册。',
  agent_step2:
    '如果您的客人投注 R$1 或以上，您就可以享受高佣金！您可以赚取最高 5% 的终身佣金，并享受终身邀请！系统将在次日早上 7 点结算前一天的佣金。',
  agent_step2_1: '获取方法：登录 - 邀请促销 - 收集佣金',
  agent_table1: '老虎机、捕鱼和区块链的投注佣金率如下：',
  agent_table1_1: '客户充值 20 投注 200',
  person: '人',
  agent_table2_title1: '会员投注',
  agent_table2_title2: '仅限老虎机游戏',
  agent_table2_example:
    '例子：您有 100 个会员，每天的总真实投注金额估计为 100 万雷亚尔。当天您收到的佣金是：1,000,000 x 1.20% 12,000 雷亚尔。每月赚取 100,000 雷亚尔的收入是很容易实现的。',
  reminder: '提醒',
  agent_reminder:
    '一个具有相同 IP、相同设备、姓名、银行卡等信息的会员账户只能参与一次，任何违反规则的人将无法获得此奖金。或者该组将被没收，账户将被永久冻结。',
  agent_step3_1: '会员的活动参与情况由系统自动统计，如果有任何异议，以 Jit993 的分析结果为准',
  agent_step3_2: '如果您忘记了会员账户/密码，请联系我们的 24 小时客户服务团队，帮助您找回账户信息',
  agent_step3_3: 'Jit993 保留随时更改、中断或取消本次促销活动的权利',
  agent_step3_4: '代理人能够以现金或钱包中的积分形式获得佣金奖金',
  agent_step3_5: '不要保存免费游戏，购买免费游戏',
  agent_step3_6: '不能与任何奖金和存款结合使用',
  agent_step3_7: '仅限老虎机游戏',
  promo_concluded: '促销已结束！请明天再来！',
  can_only_claim: '只能在巴西时间 {{x}} 到 {{y}} 之间领取奖金',
  please_login: '请先登录以领取奖金！',
  back_to_home: '返回首页',
  bonus_claimed: '奖金已领取！',
  wallet: '钱包',
  bank_bsb: `银行 BSB`,
  pay_id: `PayID`,
  from_selected_promotion: '从选定的促销中',
  helpful_links: '帮助链接',
  platform: '平台',
  community: '社区',
  support: '支持',
  partnership_program: '合作计划',
  help_center: '帮助中心',
  sports_policy: '体育政策',
  aml_policy: '反洗钱政策',
  level: '级别',
  back: '回去',
  network_error: '网络错误',
  we_have_sent_otp: '我们已将 OTP 发送到您的电话号码',
  your_otp_expire: '您的 OTP 将于',
  didnt_receive: '没有收到消息？',
  send_again: '重新发送',
  resend_again: '再次重新发送',
  invalid_verification: '无效验证码！',
  otp_expired: 'OTP 已过期，请重新输入您的电话号码并重试！',
  otp_expired_redirect: '一次性密码已过期！重定向到登录',
  captcha_check_failed: '验证码检查失败！',
  verify_phonenumber: '验证电话号码',
  send_otp: '发送一次性密码',
  success_verification: '您的电话号码已被验证！',
  press_get_code: '按获取代码按钮通过短信接收验证码',
  otp_sent: '验证码已发送！输入下面的验证码继续',
  get_code: '获取代码',
  verify: '核实',
  verification_code: '验证码',
  otp_not_found: '未找到 OTP 功能！',
  terms_n_conditions: `TERMS AND CONDITION`,
  the_activity_x_in: `活动 {{x}} 在`,
  total_deposit_in_a_month: `一个月内的总存款`,
  daily_withdraw_limit: `每日提款限额`,
  transaction_counts: `交易次数`,
  vip_birthday_bonus: `生日奖金`,
  daily_rebate: `每日回扣`,
  vip_maintenance_3_mo: `VIP维护服务3个月`,
  starts: `开始`,
  ends: `结束`,
  list_of_winners: `获奖者名单`,
  days: `天`,
  hours: `小时`,
  minutes: `分钟`,
  seconds: `秒数`,
  total_amount_received: `收到的总金额`,
  claim: `宣称`,

  docs: {
    hi: `嗨`,
    description: `需要帮助吗？\n 请查看我们的文档。`,
    documentation: `文档`,
  },
  user: `用户`,
  list: `列表`,
  edit: `编辑`,
  shop: `商店`,
  blog: `博客`,
  post: `帖子`,
  mail: `邮件`,
  chat: `聊天`,
  posts: `帖子`,
  create: `创建`,
  kanban: `看板`,
  general: `通用`,
  banking: `银行`,
  booking: `预订`,
  product: `产品`,
  invoice: `发票`,
  checkout: `结账`,
  calendar: `日历`,
  analytics: `分析`,
  ecommerce: `电子商务`,
  management: `管理`,
  menu_level_1: `菜单级别 1`,
  menu_level_2: `菜单级别 2`,
  menu_level_3: `菜单级别 3`,
  item_disabled: `项目已禁用`,
  item_label: `项目标签`,
  item_caption: `项目说明`,
  description: `描述`,
  other_cases: `其他情况`,
  item_by_roles: `按角色分配的项目`,
  only_admin_can_see_this_item: `仅管理员可见此项目`,
  number_exists: '该电话号码已被注册',
  number_not_exists: '该电话号码尚未注册',
  payment_draft: '如果您确认已付款，请稍等片刻，因为付款可能仍在处理中',
  card_game: '纸牌游戏',
  card: '如果您确认已付款',
  live_chat: '在线聊天',
  fullname_note: '确保您的全名与您的银行账户匹配，以避免提款问题。',
  please_download_x_to_play: '请下载{{x}}以进行游戏。',
  password: '密码',
  play_now: '立即游戏',
  vip_benefits: 'VIP福利',
  no_limits: '无限制',
  promo: '促销',
  no_limits_description:
    '我们为所有VIP俱乐部的玩家提供个性化的VIP服务和独特的游戏条件。现在你可以毫无顾虑地玩了！这非常简单——为了刺激而玩，提升你的游戏技能，享受你的时光，并且在获胜机会方面没有限制！',
  financial_privileges: '财务特权',
  financial_privileges_description:
    'VIP俱乐部欢迎所有希望获得高质量VIP服务的玩家。在我们的网站上为您提供独家特权、特别促销和福利！VIP玩家的身份解锁了更高的提款限额，而且时间非常短！尽情享受吧！',
  personal_manager: '私人经理',
  personal_manager_description:
    '当您成为VIP玩家时，您希望获得哪些优势？与您的私人经理分享您的想法，并告诉我们您希望在我们的网站上看到的更多内容！我们始终乐于接受伟大的建议！',
  vip_promotions: 'VIP促销',
  vip_promotions_description:
    '您是否希望获得更多的精彩促销，VIP玩家可以享受所有这些以及更多的奖励作为忠诚的回报！成为其中一员吧！',
  become_vip: '成为VIP',
  play_the_way_you_want: '按照您想要的方式玩',
  join_vip_program: '立即加入VIP计划！',
  join_now: '立即加入',
  vip_club: 'VIP俱乐部',
  withdraw_limit: '提现限额',
  cashback: '现金返还',
  personal_account_manager: '个人账户经理',
  dont_show_again: '不再显示',
  next: '下一步',
  close: '关闭',
  logout_confirmation: '退出确认',
  are_you_sure_to_logout: '您确实要退出吗？',
  you_can_reach_media_platforms: '您可以通过我们的任何社交媒体平台与我们联系',
  no_data: '无数据',
  total_deposit: `总存款`,
  more_games: '更多游戏',
  favorite_game: '最喜欢的游戏',
  total_balance: `总余额`,
  language: `语言`,
  vip_center: `贵宾中心`,
  join_community: `加入我们的社区`,
  preferred_bank: `首选银行`,
  account_holder: `账户持有人`,
  select_bank: `选择银行`,
  enter_here: `在此输入`,
  today: `今天`,
  all_type: `所有类型`,
  no_record_found: `未找到记录`,
  yesterday: `昨天`,
  last_three_days: '过去3天',
  last_seven_days: '过去7天',
  last_15_days: '过去15天',
  last_30_days: '过去30天',
  date_time: `日期和时间`,
  transaction_id: `交易ID`,
  transaction_type: `交易类型`,
  successful: `成功的`,
  approve: `批准`,
  completed: `完全的`,
  pending: `待办的`,
  failed: `失败的`,
  mobile: `移动的`,
  enter_code: `请输入代码`,
  request_otp: `请求 OTP`,
  continue: `继续`,
  not_received_otp: `没有收到验证码？`,
  sending: `正在发送...`,
  resend_in: `重新发送`,
  please_enter_new_password: '请输入您的新密码',
  password_contain: `密码必须至少包含以下内容`,
  six_characters: `至少 6 个字符`,
  contains_letters_numbers: `包含一个字母和一个数字`,
  enter_new_password: `输入新密码`,
  confirm_new_password: `确认新密码`,
  receipt: `收据`,
  important_notice: `重要通知`,
  always_check_for_latest_active: `存款前务必查看最新的有效存款银行信息。`,
  depositors_name_must_match: `存款人的账户名称必须与注册的全名一致。我们不鼓励使用第三方/公司账户进行交易。`,
  for_using_bank_transfer: `如果选择“银行转账”作为存款方式，请在提交交易前完成转账，以免交易延迟。`,
  please_do_not_fill_sensitive: `请勿在网上转账交易中填写任何与赌博相关的敏感词语作为参考/备注。`,
  please_take_note: `请注意，所有存款均需达到 1 倍流水要求后才能处理提款。`,
  kindly_check_live_chat: `如果您的交易超过 5 分钟仍未处理，请联系我们的 24/7 在线客服进行查询。`,
  min_amount: `最低金额`,
  minimum_deposit_is: `最低存款额为`,
  deposit_channel: `充值渠道`,
  remember_password: `记住密码`,
  enter_password: `输入密码`,
  dont_you_have_account: `还没有账号？`,
  create_account_now: `立即创建帐户`,
  contact_number: `联系电话`,
  enter_account_number: `输入帐号`,
  select_currency: `选择货币`,
  i_agree_the: `我同意`,
  terms_of_use: `使用条款`,
  and: `和`,
  wallet_balance: `钱包余额`,
  restore: `恢复`,
  others: `其他的`,
  havent_login_yet: `还没登录呢……`,
  login_register_now: `立即登录/注册！`,
  hot_news: `热点新闻`,
  daily_checkin: `每日签到`,
  total_earn: `总收入`,
  double_reward_checkin: `连续签到可获得双倍奖励`,
  claim_now: `立即领取`,
  check_in_history: `签到历史`,
  no_history_yet: `还没有历史记录`,
  more: `更多的`,
  from_provider: `来自提供商`,
  to_provider: `致供应商`,
  transfer_amount: `转账金额`,
  available_amount: `可用数量`,
  turnover_requirement: `营业额要求`,
  promo_code: `促销代码`,
  enter_your_promo_code: `输入您的促销代码`,
  select_provider: `选择提供商`,
  phone_number_not_associated: `该电话号码未关联任何帐户，请重新输入。`,
  old_password: `旧密码`,
  id: `ID`,
  how_to_deposit: `如何存款？`,
  how_to_withdrawal: `如何提现？`,
  how_to_top_up: `如何充值？`,
  how_to_add_homescreen: `如何添加到主屏幕？`,
  search_game_name: `搜索游戏名称`,
  please_enter_correct_username: `请输入正确的用户名`,
  please_enter_correct_password: `请输入正确的密码`,
  enter_username: `输入用户名`,

  our_commitment: `我们的承诺`,
  our_commitment_desc: `我们致力于推动负责任的游戏行为，并确保平台始终为所有玩家提供一个安全、可控且愉快的环境。虽然游戏本质上是一种娱乐方式，但我们也重视帮助用户保持健康的习惯，并对自身行为进行良好控制。`,
  play_responsibly: `理性游戏`,
  play_subtitle: `我们鼓励所有玩家：`,
  play_responsibly_desc1: `将游戏视为娱乐，而非收入来源`,
  play_responsibly_desc2: `为时间与支出设定个人限制`,
  play_responsibly_desc3: `避免追逐损失`,
  play_responsibly_desc4: `在游戏过程中定期休息`,
  play_responsibly_desc5: `仅使用可承受损失的资金进行游戏`,
  underage_protection: `未成年人保护`,
  underage_protection_subtitle1: `本平台严禁未满18岁（或未达到当地法定年龄）的用户使用。`,
  underage_protection_subtitle2: '我们采取积极措施防止未成年人参与游戏，包括：',
  underage_protection_desc1: `身份验证程序`,
  underage_protection_desc2: `账户监控`,
  underage_protection_desc3: `一旦发现未成年人账户将立即暂停`,
  self_control_tools: `自我控制工具`,
  self_control_tools_subtitle1: `为支持负责任的游戏，我们提供多种工具帮助玩家管理自身行为，包括：`,
  self_control_tools_desc1: `存款限额`,
  self_control_tools_desc2: `游戏时间提醒`,
  self_control_tools_desc3: `冷静期（暂停使用）`,
  self_control_tools_desc4: `自我排除选项`,
  self_control_tools_subtitle2: `如玩家需要暂时停止游戏，可联系客户支持团队协助启用相关功能。`,
  sign_of_problem_gaming: `问题游戏的迹象`,
  sign_of_problem_gaming_subtitle1: `如果您出现以下情况，可能需要暂停游戏：`,
  sign_of_problem_gaming_desc1: `花费的时间或金钱超过预期`,
  sign_of_problem_gaming_desc2: `借钱进行赌博`,
  sign_of_problem_gaming_desc3: `持续追逐损失`,
  sign_of_problem_gaming_desc4: `忽视工作、家庭或其他责任`,
  sign_of_problem_gaming_desc5: `因游戏感到压力、焦虑或沮丧`,
  sign_of_problem_gaming_subtitle2: `及早识别这些迹象非常重要。`,
  support_and_assistance: `支持与帮助`,
  support_and_assistance_subtitle1: `如果您或您身边的人可能面临与赌博相关的问题，我们强烈建议寻求专业帮助。许多机构提供保密的支持与指导。`,
  support_and_assistance_subtitle2: `您可以考虑联系：`,
  support_and_assistance_desc1: `当地咨询服务`,
  support_and_assistance_desc2: `专业支持机构`,
  support_and_assistance_desc3: `国家热线服务`,
  our_responsibility: `我们的责任`,
  our_responsibility_subtitle1: `我们会主动监控玩家活动，以识别异常或潜在有害行为。如有需要，我们可能会：`,
  our_responsibility_desc1: `提供建议或警告`,
  our_responsibility_desc2: `建议设置限制或休息时间`,
  our_responsibility_desc3: `暂时限制账户访问以保护玩家`,
  contact_us_responsible: `联系我们`,
  contact_us_subtitle: `如果您需要帮助或希望启用任何负责任游戏工具，请联系我们的客服团队。我们将协助您保持安全、健康且愉快的游戏体验。`,

  by_accessing_our_platform: `通过访问和使用本平台，即表示您同意遵守并受本《条款与条件》的约束。如您不同意，请停止使用我们的服务。`,
  we_reserve_rights: `我们保留在任何时间对本条款进行修改、更新或更改的权利，恕不另行通知。您继续使用本平台即表示您接受更新后的条款。`,
  eligibility: `资格`,
  eligibility_desc1: `用户必须年满18岁（或符合所在司法管辖区的合法年龄）。`,
  eligibility_desc2: `用户需自行确保在线游戏在其所在国家是合法的。`,
  eligibility_desc3: `我们有权暂停或终止不符合资格要求的账户。`,
  account_responsibility: `账户责任`,
  account_responsibility_desc1: `用户在注册时必须提供准确且完整的信息。`,
  account_responsibility_desc2: `每位用户仅允许拥有一个账户。`,
  account_responsibility_desc3: `用户有责任妥善保管其登录信息的机密性。`,
  account_responsibility_desc4: `您账户下的所有活动均视为由您本人负责。`,
  deposit_withdrawal: ` 存款与提款`,
  deposit_withdrawal_desc1: `所有存款必须通过认可的支付方式进行。`,
  deposit_withdrawal_desc2: `提款需经过验证及合规审核。`,
  deposit_withdrawal_desc3: `如发现可疑活动，我们有权延迟或拒绝提款。`,
  deposit_withdrawal_desc4: `处理时间可能因支付服务提供商而有所不同。`,
  bonuses_promotions: `奖金与促销`,
  bonuses_promotions_desc1: `所有奖金、奖励及促销活动均受特定条款约束。`,
  bonuses_promotions_desc2: `严禁滥用促销（包括多账户或欺诈行为）。`,
  bonuses_promotions_desc3: `对于通过滥用获得的奖金及盈利，我们有权予以取消。`,
  fair_play_usage: `公平游戏与使用`,
  fair_play_usage_desc1: `玩家必须以公平及合法的方式使用本平台。`,
  fair_play_usage_desc2: `严禁操控游戏、利用系统漏洞或从事欺诈行为。`,
  fair_play_usage_desc3: `如发生系统错误，我们有权取消相关投注及盈利。`,
  multiple_accounts_ip_policy: `多账户与IP政策`,
  multiple_accounts_ip_policy_desc1: `严禁同一用户拥有多个账户。`,
  multiple_accounts_ip_policy_desc2: `如发现多个账户使用相同IP地址或存在关联行为，我们有权：`,
  multiple_accounts_ip_policy_desc2_1: `暂停或终止账户`,
  multiple_accounts_ip_policy_desc2_2: `取消所有盈利`,
  multiple_accounts_ip_policy_desc2_3: `仅退还原始存款金额`,
  provider_game_issues: `供应商与游戏问题`,
  provider_game_issues_desc1: `所有游戏均由第三方供应商提供。`,
  provider_game_issues_desc2: `如出现技术问题、错误或数据差异，我们有权：`,
  provider_game_issues_desc2_1: `相应调整账户余额`,
  provider_game_issues_desc2_2: `取消受影响的投注或盈利`,
  provider_game_issues_desc3: `基于供应商报告所作的决定为最终决定。`,
  account_suspension_termination: `账户暂停与终止`,
  account_suspension_termination_subtitle: `在以下情况下，我们有权暂停或永久关闭账户：`,
  account_suspension_termination_desc1: `违反条款与条件`,
  account_suspension_termination_desc2: `发现欺诈或可疑活动`,
  account_suspension_termination_desc3: `未完成必要的验证程序`,
  limitation_of_liability: `责任限制`,
  limitation_of_liability_subtitle: `我们不对以下情况承担责任：`,
  limitation_of_liability_desc1: `因用户疏忽造成的损失`,
  limitation_of_liability_desc2: `超出我们控制范围的技术问题l`,
  limitation_of_liability_desc3: `由第三方服务导致的延迟`,
  limitation_of_liability_subtitle2: `使用本平台的风险由您自行承担。`,

  introduction: `引言`,
  introduction_subtitle1: `我们致力于保护您的隐私，并确保您的个人信息以安全和负责任的方式被处理。本隐私政策说明了当您使用我们的平台时，我们如何收集、使用、存储和保护您的信息。`,
  introduction_subtitle2: `通过访问或使用我们的服务，即表示您同意本隐私政策中的条款。`,
  information_we_collect: `我们收集的信息`,
  information_we_collect_subtitle1: `我们可能会收集以下类型的信息:`,
  information_we_collect_desc1: `个人信息`,
  information_we_collect_desc1_1: `姓名`,
  information_we_collect_desc1_2: `电子邮箱地址`,
  information_we_collect_desc1_3: `联系方式`,
  information_we_collect_desc1_4: `出生日期`,
  information_we_collect_desc1_5: `支付信息`,
  information_we_collect_desc2: `账户信息`,
  information_we_collect_desc2_1: `用户名及登录凭证`,
  information_we_collect_desc2_2: `交易记录（存款与提款）`,
  information_we_collect_desc2_3: `游戏活动及偏好`,
  information_we_collect_desc3: `技术信息`,
  information_we_collect_desc3_1: `IP地址`,
  information_we_collect_desc3_2: `设备信息`,
  information_we_collect_desc3_3: `浏览器类型`,
  information_cookies: `Cookie及使用数据`,
  how_we_use_information: `我们如何使用您的信息`,
  how_we_use_information_subtitle1: `您的信息可能用于以下目的：`,
  how_we_use_information_desc1: `创建和管理您的账户`,
  how_we_use_information_desc2: `处理存款与提款`,
  how_we_use_information_desc3: `提供客户支持`,
  how_we_use_information_desc4: `改善平台及用户体验`,
  how_we_use_information_desc5: `检测和防止欺诈、滥用或非法活动`,
  how_we_use_information_desc6: `遵守法律及监管要求`,
  sharing_of_information: `信息共享`,
  sharing_of_information_subtitle1: `我们不会出售您的个人数据。但在以下情况下，我们可能会共享您的信息：`,
  sharing_of_information_desc1: `服务提供商（支付处理、IT服务）`,
  sharing_of_information_desc2: `游戏供应商（用于游戏及交易验证`,
  sharing_of_information_desc3: `法律要求下的监管机构`,
  sharing_of_information_desc4: `防欺诈机构以防止滥用行为e`,
  sharing_of_information_subtitle2: `所有第三方均需安全地处理您的数据。`,
  data_security: `数据安全`,
  data_security_subtitle1: `我们采取先进的安全措施保护您的信息，包括：`,
  data_security_desc1: `加密技术 `,
  data_security_desc2: `安全服务器与防火墙`,
  data_security_desc3: `访问控制与监控系统`,
  data_security_subtitle2: `尽管我们尽力保护您的数据，但没有任何系统是绝对安全的。用户需自行保管好登录信息的机密性。`,
  cookie_policy: `Cookie政策`,
  cookie_policy_subtitle1: `我们使用Cookie及类似技术来：`,
  cookie_policy_desc1: `提升用户体验`,
  cookie_policy_desc2: `记住用户偏好`,
  cookie_policy_desc3: `分析平台使用情况`,
  cookie_policy_subtitle2: `您可以通过浏览器设置禁用Cookie，但部分功能可能无法正常使用。`,
  data_retention: `数据保留`,
  data_retention_subtitle1: `我们仅在必要期间内保留您的个人数据，以：`,
  data_retention_desc1: `实现本政策中所述目的`,
  data_retention_desc2: `遵守法律和监管义务`,
  data_retention_subtitle2: `当数据不再需要时，将被安全删除或匿名化处理。`,
  your_rights: `您的权利`,
  your_rights_subtitle1: `根据您所在的司法管辖区，您可能享有以下权利：`,
  your_rights_desc1: `访问您的个人数据`,
  your_rights_desc2: `要求更正不准确的信息`,
  your_rights_desc3: `要求删除您的数据`,
  your_rights_desc4: `限制或反对数据处理`,
  your_rights_subtitle2: `如需行使上述权利，请联系我们的客服团队。`,

  step_one: `步骤1`,
  step_two: `步骤2`,
  step_three: `步骤3`,
  step_four: `步骤4`,
  add_to_home_screen: `添加到主屏幕`,

  top_casino: `Padu99`,
  play_big: `玩稳九九，赢劲久久`,

  asia_biggest_most_trusted: `Padu99，规模最大、最值得信赖的平台。携手亚洲领先的体育品牌Saba Sports，为您带来更精彩的投注体验！`,
  fast: '快速',
  seamless: '无缝',
  stay_updated: '保持更新',
  smart_betting: '智能投注',
  security: '安全',
  live_streaming: '直播',
  no_login_required: '首次登录后，无需再次登录即可访问 Saba Sports 应用程序。',
  deposit_and_withdraw_direct: '可直接通过应用程序进行存款和取款。',
  receive_instant_notification: '接收所关注赛事的即时通知。',
  access_valuable_information: '获取有价值的信息和统计数据，以做出更明智的决策。',
  guarantees_data_transaction: '通过先进功能保障数据和交易安全，建立信任并为玩家提供高度安全的交易环境。',
  live_watches: '可在应用内观看比赛直播',
  malaysia: `马来西亚`,
  dns_title: '设置公共 DNS',
  description_1:
    '1.1.1.1: Faster Internet 是在 iOS 和 Android 设备上设置 1.1.1.1 DNS 解析器的首选方法。它允许您自动配置手机在任何连接的网络上使用 1.1.1.1，并解决 iOS 和 Android 在蜂窝网络下无法使用替代 DNS 解析器的问题。',
  description_2:
    '该应用还允许您启用 DNS 查询加密或启用 WARP 模式，这可以保护您所有 HTTP 流量的隐私和安全，包括对 1.1.1.1 的 DNS 查询。',
  description_3: '您可以在 1.1.1.1: Faster Internet 的设置中选择这两种选项。默认情况下，应用配置为 WARP 模式。',
  how_to_provide_faster_internet: '设置 1.1.1.1: Faster Internet',
  step1_title: '下载',
  step1_desc: '从 App Store 或 Google Play 免费下载 1.1.1.1: Faster Internet',
  step2_title: '打开',
  step2_desc: '打开应用并同意服务条款。',
  step3_title: '安装',
  step3_desc: '安装 VPN 配置文件，使手机能够安全连接到 1.1.1.1。',
  step4_title: '允许',
  step4_desc: '允许添加 VPN 配置。',
  step5_title: '连接',
  step5_desc: '切换 WARP 按钮至“已连接”状态。',
  provider: '提供者',
  day: `天`,
  withdrawal_amount: '提款金额',
  withdrawal_remaining: '剩余提款额',
  selected_bank_details: `选定的银行账户信息`,
  withdraw_count: `提款次数`,
  weekly_rebate: `每周返利`,
  tier_bonus_upgrade: `级别奖金升级`,
  special_birthday_gift: `特别生日礼物`,
  upgrade_next_tier: `升级到下一级`,
  maintenance_requirement: `维护要求`,
  valid_until: `有效期至`,
  membership_renewal: `会员续费`,
  vip: `贵宾`,
  unlimited: '无限',
  yes: '是',
  no: '否',
  months: '月',
  lifetime: '终身',
  bronze: '青铜',
  silver: '白银',
  gold: '黄金',
  platinum: '铂金',
  diamond: '钻石',
  royal: '皇家',

  about_us_welcome: `欢迎来到 Padu99 —— 您值得信赖的高端线上娱乐与游戏首选平台。`,
  about_us_forward_thinking: `我们是一家具有前瞻性的在线游戏公司，致力于为全球玩家提供世界级的娱乐体验。平台建立在创新、可靠性以及用户满意度的基础之上，汇集了丰富多样的游戏选择，包括老虎机、真人娱乐场、桌面游戏以及其他互动体验，均由业内领先且信誉良好的游戏供应商提供支持。`,
  about_us_goal: `我们的目标很简单：打造一个让玩家能够享受流畅游戏体验、丰富奖励以及安心无忧环境的平台。我们深知信任在在线游戏中的重要性，因此在所有运营环节中，我们始终坚持公平、透明与安全的原则。平台上的所有游戏均符合严格标准，确保结果公正，并为玩家带来真正愉快的体验。`,
  about_us_beyond_entertainment: `除了娱乐，我们也致力于为玩家创造实际价值。通过完善的奖励体系——包括存款奖金、积分奖励、每日签到奖励以及幸运转盘活动——我们希望在提升用户参与度的同时，让玩家在平台上获得更多回报。每一项功能都经过精心设计，以提升娱乐性和奖励潜力。`,
  about_us_invest_technology: `我们也持续加大在技术方面的投入，以确保平台始终保持高速、稳定和安全。从先进的加密系统到强大的后端基础设施，我们致力于保护用户数据，并提供顺畅、不中断的游戏体验。`,
  about_us_customer_satisfaction: `客户满意度始终是我们的核心。我们的专业客服团队随时准备为玩家提供及时支持，高效解决问题并耐心解答疑问。我们相信优质的服务能够建立长期的信任关系，并承诺在每一个环节为玩家提供支持。`,

  username_must_be: `用户名长度必须介于 6 到 20 个字符之间。`,
  fullname_must_be: `全名只能包含字母和空格。`,
  fullname_required: `必须提供全名`,
  password_must_be: `密码长度必须介于 4 到 20 个字符之间。`,
  contact_number_must: `联系电话必须以6开头，后跟10或11位数字。`,
  account_number_required: `需要提供账号。`,
  no_bank_accounts_added: `未添加银行账户`,
  agree_tnc: `您需要同意使用条款和隐私政策才能登录。`,
  i_agree: `我同意`,
  send_code_mobile: `我们会向您的手机号码发送验证码`,
  correct_code: `请输入正确的验证码`,
  resend_code: `重新发送代码`,
  resend_code_now: `立即重新发送验证码`,
  enter_valid_phone: `请输入有效的电话号码`,

  withdrawal_bank_account_name: `取款银行账户名称必须与注册账户的全名一致。`,
  some_game_provider: `有些游戏提供商需要 15 到 30 分钟的报告同步时间。`,
  please_make_sure_turn_over: `请确保您已达到营业额要求。.`,
  withdrawal_remaining_limit: `剩余提款限额`,
  select_promotion: `选择促销`,
  to_upgrade_to: `升级到`,
  Whatsapp: `Whatsapp`,
  marquee_announcement: `玩稳九九，赢劲久久！立即注册 —— 火热优惠、极速奖金，还有令人难忘的游戏体验等着你!`,
  no_withdraw_bank_account_yet: `尚未开通提款账户`,
  for_quick_access: `快速访问`,
  tap_share_button: `点击分享按钮`,
  tap_add_home_screen: `点击“添加到主屏幕”`,
  tap_add: `点击添加`,
  processing: `加工`,
  select_your_bank: `选择您的银行`,
  add_bank_failed: `添加银行失败`,
  add_bank: `添加银行`,
  reject: `拒绝`,
  in_progress: `进行中`,
};

export default cn;
